import React, { Fragment } from 'react'
import styled, { css } from 'styled-components'

import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import { white } from '../../theme/colors';
import { SelectFilter } from '../../pages/dashboard/components/SelectFilter';

const PaginationContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;

  @media (max-width: 767px) {
    justify-content: center;
    width: 100%;
  }
`

const PageSizeWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #64748b;
  font-family: 'Inter', 'Barlow', sans-serif;
  font-weight: 500;
`

const PageSizeSelect = styled.div`
  display: inline-flex;
  align-items: center;
  height: 36px;
  border: 1.5px solid #e2e8f0;
  border-radius: 8px;
  background: ${white};
  box-shadow: 0 1px 3px rgba(0,0,0,0.04);
  min-width: 70px;
`

const Divider = styled.div`
  width: 1px;
  height: 20px;
  background: #e2e8f0;
  border-radius: 1px;

  @media (max-width: 767px) {
    display: none;
  }
`

const NavGroup = styled.div`
  display: flex;
  align-items: center;
  height: 36px;
  border: 1.5px solid #e2e8f0;
  border-radius: 8px;
  background: ${white};
  box-shadow: 0 1px 3px rgba(0,0,0,0.04);
  overflow: hidden;
`

const NavIconWrapper = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  cursor: pointer;
  color: #475569;
  transition: all 0.18s ease;

  &:hover:not([disabled]) {
    background: #f1f5f9;
    color: #6366f1;
  }

  ${props => props.disabled && css`
    opacity: 0.35;
    cursor: not-allowed;
    pointer-events: none;
  `}

  svg {
    font-size: 20px;
  }
`

const PageInfo = styled.span`
  padding: 0 12px;
  font-size: 13px;
  font-weight: 500;
  color: #475569;
  font-family: 'Inter', 'Barlow', sans-serif;
  white-space: nowrap;
  border-left: 1.5px solid #e2e8f0;
  border-right: 1.5px solid #e2e8f0;
  height: 36px;
  display: flex;
  align-items: center;
`

const Pagination = ({
  count,
  current,
  totalPages,
  onNextPageClick,
  onPrevPageClick,
  pageSize = 15,
  onPageSizeChange
}) => {
  const paginationOptions = [
    { value: 15, label: 15 },
    { value: 30, label: 30 },
    { value: 50, label: 50 },
    { value: 100, label: 100 },
    { value: 500, label: 500 },
    { value: 1000, label: 1000 },
  ];

  return (
    <PaginationContainer>
      {/* Page size selector */}
      <PageSizeWrapper>
        <span>Show</span>
        <PageSizeSelect>
          <SelectFilter
            props={{
              menuPlacement: 'top',
              width: '70px',
              options: paginationOptions,
              name: 'page-size',
              placeholder: '--',
              onChange: onPageSizeChange,
              value: paginationOptions.filter(({ value }) => value === pageSize),
              isSearchable: false,
              isDisabled: false,
              noBorder: true,
              menuPortalTarget: typeof document !== 'undefined' ? document.body : null,
            }}
            height={'36px'}
          />
        </PageSizeSelect>
        <span>rows</span>
      </PageSizeWrapper>

      <Divider />

      {/* Prev / page info / Next */}
      <NavGroup>
        <NavIconWrapper
          disabled={!onPrevPageClick}
          onClick={onPrevPageClick ? () => onPrevPageClick() : null}
          title="Previous page"
        >
          <NavigateBeforeIcon />
        </NavIconWrapper>

        <PageInfo>
          {current || 1} / {totalPages || 1}
        </PageInfo>

        <NavIconWrapper
          disabled={!onNextPageClick}
          onClick={onNextPageClick ? () => onNextPageClick() : null}
          title="Next page"
        >
          <NavigateNextIcon />
        </NavIconWrapper>
      </NavGroup>
    </PaginationContainer>
  )
}

export default Pagination
